import shirtImage from '../../images/T-Shirt.jpg'

const data = [
  {
    id: 1,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$150",
  },
  {
    id: 2,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 3,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 4,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 5,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 6,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 7,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 8,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 9,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 10,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 11,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 12,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
  {
    id: 13,
    image: shirtImage,
    title: "Men T-Shirt",
    desc: "Description",
    rate: "4/5",
    price: "$120",
  },
];

export default data;
